import { ICandidate, newMappingEntity } from 'wisestep-api';

import CareerBuilderCandidates from '../types/CareerBuilderCandidates';
import CareerBuilderResponse from '../types/CareerBuilderResponse';

export const processCareerBuilderResponse = (response: any): CareerBuilderResponse => {
  let existing: any = null;
  let noresponse = false;
  const modifiedResponse: CareerBuilderResponse = {
    candidates: [],
  };
  if (response.string?.Existing?.interaction) {
    if (Array.isArray(response.string.Existing.interaction)) {
      existing = response.string.Existing.interaction;
    } else {
      existing = [response.string.Existing.interaction];
    }
  } else {
    existing = [];
  }

  const totalItems = response.string.Packet.Hits;

  if (!response.string.Packet.Results.ResumeResultItem_V3) {
    noresponse = true;
  }
  const candidates = response.string.Packet.Results.ResumeResultItem_V3
    ? Array.isArray(response.string.Packet.Results.ResumeResultItem_V3)
      ? response.string.Packet.Results.ResumeResultItem_V3
      : [response.string.Packet.Results.ResumeResultItem_V3]
    : [];
  const candidatesResponse = buildCandidateRecords(candidates);
  modifiedResponse.candidates = candidatesResponse;
  modifiedResponse.noResponse = noresponse;
  modifiedResponse.totalItems = totalItems;
  modifiedResponse.existing = existing;
  return modifiedResponse;
};

function buildCandidateRecords(candidates: CareerBuilderCandidates[]): CareerBuilderCandidates[] {
  candidates.map((candidate) => {
    const candidateData: ICandidate = newMappingEntity();

    candidateData.name = `${candidate.ContactName}`;
    candidateData.currentJobTitle = candidate.JobTitle;
    candidateData.source = 'CAREERBUILDERSEARCH';
    candidateData.dateLastActiveOnJobBoard = candidate.LastActivity;
    candidateData.dateResumeLastUpdatedOnJobBoard = candidate.LastUpdate;
    candidate.candidateData = candidateData;
  });
  return candidates;
}
